import { FeedItemPublishingDTO } from '../dtos/FeedItemPublishing.dto';
import { FeedItemPublishingLogModel } from '../models/FeedItemPublishingLog.model';

export class FeedItemPublishingLogUtils {
  public static mapToViewModel(
    dto: FeedItemPublishingDTO,
  ): FeedItemPublishingLogModel {
    return {
      logged: dto.logged,
      type: dto.type,
      member: {
        email: dto.member.email,
        fullName: this.getFullName(dto),
        scope: dto.member.details.scope,
        username: dto.member.details.username,
      },
    };
  }

  private static getFullName(dto: FeedItemPublishingDTO): string {
    return `${dto.member.details.firstName} ${dto.member.details.lastName}`;
  }
}
